/**
 * Handle auth token error
 */
export const handleUnAuthorized = () => {
  console.log("Authorization failed")
}